import getMinutes from '@teetsh/app/src/utils/time/getMinutes';
import setMinutes from '@teetsh/app/src/utils/time/setMinutes';

export function getFloorStepTime(date: Date, timeGap: number): Date {
  const minutes = getMinutes(date);
  const floorStep = Math.floor(minutes / timeGap) * timeGap;
  return setMinutes(date, floorStep);
}
